import { Modal, ModalProps } from 'antd';
import useModal from 'hooks/useModal';
import { ReactScrollProvider } from 'views/Aide/components/ReactScrollContext';
import {
  modalClassName,
  Container,
} from 'views/Conversation/Chat/components/MessageScenario/ScenarioModal';
import { ScenarioDetailContent, ScenarioDetailHeader } from 'views/PureLLM/ScenarioDetailModal';

interface Props extends ModalProps {
  region: General.UpperCaseRegion;
  storeId: string;
  storeGroupId: string;
  storeGroupName: string;
  intentId: string;
  policyId: string;
  subPolicyId: string;
}

function LlmModal({
  region,
  storeId,
  storeGroupId,
  storeGroupName,
  intentId,
  policyId,
  subPolicyId,
  ...otherProps
}: Props) {
  return (
    <Modal
      title={
        <ScenarioDetailHeader
          enabled={otherProps.visible || false}
          region={region}
          storeId={storeId}
          storeGroupId={storeGroupId}
          intentId={intentId}
        />
      }
      width="80vw"
      footer={false}
      className={modalClassName}
      {...otherProps}
    >
      <ReactScrollProvider>
        <Container>
          <ScenarioDetailContent
            enabled={otherProps.visible || false}
            region={region}
            storeId={storeId}
            storeGroupId={storeGroupId}
            storeGroupName={storeGroupName}
            intentId={intentId}
            policyId={policyId}
            subPolicyId={subPolicyId}
            hideDetailTitleBar
          />
        </Container>
      </ReactScrollProvider>
    </Modal>
  );
}

export function useLlmModal() {
  const { visible, show, hide, meta } = useModal<Props>();

  const modal = meta && <LlmModal {...meta} visible={visible} onCancel={() => hide()} />;

  return [modal, show] as const;
}

export default LlmModal;
